"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTile = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tile = require("./Tile.styles");

var _atoms = require("../../atoms");

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const IconTile = /*#__PURE__*/(0, _react.forwardRef)(({
  label,
  iconName,
  onRemove,
  onClick,
  fill,
  showCustomization,
  ...restProps
}, ref) => {
  return /*#__PURE__*/_react.default.createElement(_Tile.IconTileContainerStyle, _extends({}, restProps, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Tile.IconTileContainerStyle, {
    onClick: onClick
  }, fill ? /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: `${iconName}`,
    size: 21,
    fill: fill,
    "data-testid": `${iconName}`,
    style: {
      cursor: 'pointer'
    },
    onClick: onClick
  }) : /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: iconName,
    size: 50,
    "data-testid": `${iconName}`,
    style: {
      cursor: 'pointer'
    },
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, (0, _utils.lineBreak)(label))), showCustomization && /*#__PURE__*/_react.default.createElement("span", {
    className: "remove",
    onClick: onRemove,
    "data-testid": `${label}-remove`
  }, "Remove"));
});
exports.IconTile = IconTile;
IconTile.propTypes = {
  label: _propTypes.default.string.isRequired,
  fill: _propTypes.default.string,
  iconName: _propTypes.default.string.isRequired,
  iconCustomProps: _propTypes.default.object,
  onClick: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  showCustomization: _propTypes.default.bool,
  capitalize: _propTypes.default.bool
};